<template lang="pug">
span#genospinner(:class="loading && !loadtext ? 'spinning' : ''" style="width:100%;height: 100%;position:relative;display:block;") {{loading &&  loadtext ? loadtext : text}}
  span.spinwrapper(v-if="loading && !loadtext" :style="`position:absolute;left:50%;top:50%;width:${size}px;height:${size}px;margin-left:${-1 * size/2}px;margin-top:${-1 * size/2}px;`" ) 
    geno-logo.genospinner.rotateLoading
</template>
<script>  
export default {  
    props: ['size', 'loading', 'text', 'loadtext'],
    data() {
    return {
    loadtext2: 'Running'
    }
    },
computed: {
    },
}
</script> 
<style>
.genospinner {
height: inherit;
width: inherit;
}
#genospinner.spinning {
color: transparent;
}
</style>

